import { FullScreenBackgroundContainer } from "../container/full-screen-background-container";

/**
 * Pre-React boot paint. Rendered synchronously (flushSync) in main.tsx just before the
 * native splash is hidden, so the WebView is never empty during handoff. It shows only
 * the branded background — the animated logo lives in <AppSplash>, which mounts once
 * inside the React tree and therefore plays through exactly once (no restart when this
 * static paint is replaced by <App />). Both use bg-violet-950, so the handoff is seamless.
 */
export const BootSplash = () => {
  return (
    <FullScreenBackgroundContainer
      imageClassName="bg-violet-950"
      className="flex flex-col items-center justify-center"
      backdrop={false}
    />
  );
};
